$(function () {
  function escapeHtml(str) {
    if (!str) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
  const axios = require("axios");
  const moment = require('moment-timezone');
  const timeZoneName = moment.tz.guess();
  const language = $('html')[0].lang;

  const messages = {
    fi: {
      confirmReset: "Haluatko varmasti tyhjentää lomakkeen ja aloittaa alusta?",
      selectFile: "Valitse vähintään yksi tiedosto.",
      selectTargetLanguage: "Valitse vähintään yksi kohdekieli.",
      maxFiles: "Voit ladata enintään {max} tiedostoa.",
      invalidType: 'Tiedosto "{name}" ei ole sallittu tiedostotyyppi. Sallitut: {allowed}',
      fileTooLarge: 'Tiedosto "{name}" on liian suuri ({size} MB). Enimmäiskoko on 20 MB.',
      uploading: "Ladataan tiedostoja...",
      uploadFailed: 'Tiedoston "{name}" lataus epäonnistui. Yritä uudelleen.',
      selectedLanguagesSummary: "Valitut kohdekielet",
      sourceLanguage: "Lähdekieli",
      targetLanguageTitle: "Kohdekieli",
      filesTitle: "Tiedostot",
      pcs: "kpl",
      summary: "Yhteenveto",
      attachments: "Liitteet",
      orderDataMissing: "Tilaustiedot puuttuvat",
      orderDataMissingText: "Huomasimme, että tilauksestasi puuttuu vaadittuja tietoja tai liitteitä. Ole hyvä ja aloita tilauksen tekeminen ensimmäisestä vaiheesta.",
      backToStep1: "Palaa ensimmäiseen vaiheeseen",
      sending: "Lähetetään...",
      sendFailed: "Tilauksen lähetys epäonnistui. Tarkista tiedot ja yritä uudelleen.",
      submitRequest: "Lähetä tarjouspyyntö"
    },
    sv: {
      confirmReset: "Är du säker på att du vill rensa formuläret och börja om?",
      selectFile: "Välj minst en fil.",
      selectTargetLanguage: "Välj minst ett målspråk.",
      maxFiles: "Du kan ladda upp högst {max} filer.",
      invalidType: 'Filen "{name}" är inte en tillåten filtyp. Tillåtna: {allowed}',
      fileTooLarge: 'Filen "{name}" är för stor ({size} MB). Maxstorlek är 20 MB.',
      uploading: "Laddar upp filer...",
      uploadFailed: 'Uppladdningen av filen "{name}" misslyckades. Försök igen.',
      selectedLanguagesSummary: "Valda målspråk",
      sourceLanguage: "Källspråk",
      targetLanguageTitle: "Målspråk",
      filesTitle: "Filer",
      pcs: "st",
      summary: "Sammanfattning",
      attachments: "Bilagor",
      orderDataMissing: "Beställningsuppgifter saknas",
      orderDataMissingText: "Vi upptäckte att det saknas obligatoriska uppgifter eller bilagor för din beställning. Vänligen börja om från det första steget.",
      backToStep1: "Tillbaka till första steget",
      sending: "Skickar...",
      sendFailed: "Misslyckades att skicka beställningen. Kontrollera uppgifterna och försök igen.",
      submitRequest: "Skicka offertförfrågan"
    }
  };

  const currentMsg = messages[language] || messages['fi'];

  let prefix;
  switch (language) {
    case "is-en":
    case "is":
      prefix = "youpret_iceland";
      break;
    case "ee-en":
    case "ee":
    case "ee-ru":
      prefix = "youpret_estonia";
      break;
    default:
      prefix = "youpret";
  }

  $.ajaxSetup({
    headers: {
      "X-TimeZoneName": timeZoneName,
      "X-Language": language,
      "X-Prefix": prefix
    }
  });

  const myProject = require('./_data/myProject');
  const envSettings = myProject[myProject.environment];

  const recaptchaSiteKey = envSettings.recaptchaSiteKey;


  // Initialize or fetch order
  let translationOrder = JSON.parse(sessionStorage.getItem('translationOrder')) || {
    files: [],
    fromLanguage: 'fi',
    toLanguage: '',
    deadline: '',
    notes: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    organization: '',
    billingAddress: ''
  };

  const step = parseInt($("#translationStep").val(), 10);

  // STEP 1 Form
  if (step === 1) {
    if (translationOrder.fromLanguage) $("#orderFromLanguage").val(translationOrder.fromLanguage);
    if (translationOrder.toLanguage && Array.isArray(translationOrder.toLanguage)) {
      $("#orderToLanguage").selectpicker('val', translationOrder.toLanguage);
    }

    $("#orderTranslationResetBtn").on("click", function () {
      if (confirm(currentMsg.confirmReset)) {
        sessionStorage.removeItem('translationOrder');
        window.location.reload();
      }
    });

    $("#orderToLanguage").on("change", function () {
      const selected = $(this).find('option:selected').map(function () { return $(this).text(); }).get();
      if (selected.length > 0) {
        $("#selectedLanguagesSummary").html("<strong>" + currentMsg.selectedLanguagesSummary + ":</strong> " + selected.join(", "));
      } else {
        $("#selectedLanguagesSummary").html("<strong>" + currentMsg.selectedLanguagesSummary + ":</strong> ");
      }
    });

    // Initial trigger
    $("#orderToLanguage").trigger("change");

    $("#orderTranslationForm").on("submit", function (e) {
      e.preventDefault();

      const filesInput = document.getElementById('orderTranslationFiles');
      if (filesInput.files.length === 0) {
        alert(currentMsg.selectFile);
        return;
      }

      const selectedToLanguages = $('#orderToLanguage option:selected').map(function () { return $(this).val(); }).get();
      if (selectedToLanguages.length === 0) {
        alert(currentMsg.selectTargetLanguage);
        return;
      }

      const myProject = require('./_data/myProject');
      const envSettings = myProject[myProject.environment];
      const Uris = {
        jsonAttachmentsAdd: envSettings.server + "/json/attachments/add",
        jsonAttachmentUpdate: envSettings.server + "/json/attachments/update",
      };

      // Tyhjennetään vanhat liitetiedot ennen uusia latauksia
      let attachmentIdArray = [];
      const files = filesInput.files;
      const fileCount = files.length;
      const maxFiles = 5;

      if (fileCount > maxFiles) {
        alert(currentMsg.maxFiles.replace('{max}', maxFiles));
        return;
      }

      const allowedExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt', '.rtf'];
      const maxFileSize = 20 * 1024 * 1024; // 20 MB

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const ext = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(ext)) {
          alert(currentMsg.invalidType.replace('{name}', file.name).replace('{allowed}', allowedExtensions.join(', ')));
          return;
        }
        if (file.size > maxFileSize) {
          alert(currentMsg.fileTooLarge.replace('{name}', file.name).replace('{size}', (file.size / 1024 / 1024).toFixed(1)));
          return;
        }
      }

      const originalBtnText = $("#orderTranslationNextBtn").text();
      $("#orderTranslationNextBtn").prop("disabled", true).text(currentMsg.uploading);

      function showUploadError(fileName, message) {
        console.error(message);
        $("#orderTranslationNextBtn").prop("disabled", false).text(originalBtnText);
        alert(currentMsg.uploadFailed.replace('{name}', fileName));
      }

      function nextFile(remainingFiles) {
        if (remainingFiles > 0) {
          grecaptcha.ready(function () {
            grecaptcha.execute(recaptchaSiteKey, { action: "submit" }).then(function (token) {
              let file = files[remainingFiles - 1];
              let data = {
                fileName: file.name,
                contentType: file.type,
                size: file.size,
                publicAccess: false,
                recaptchaToken: token,
              };
              $.ajax({
                url: Uris.jsonAttachmentsAdd,
                method: "POST",
                data: JSON.stringify(data),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
              }).done(function (data) {
                let location = data.location;
                let attachmentId = data.attachmentId;

                fetch(location, {
                  method: 'PUT',
                  headers: { "Content-Type": file.type },
                  body: file
                }).then(function (response) {
                  if (!response.ok) throw new Error("Upload failed with status " + response.status);
                  $.ajax({
                    url: Uris.jsonAttachmentUpdate,
                    method: "PUT",
                    contentType: "application/json; charset=utf-8",
                    data: JSON.stringify({ id: attachmentId, status: "COMPLETE" }),
                  }).done(function () {
                    attachmentIdArray.push(attachmentId);
                    nextFile(remainingFiles - 1);
                  }).fail(function (err) {
                    showUploadError(file.name, 'Failed to complete attachment status: ' + err);
                  });
                }).catch(function (err) {
                  showUploadError(file.name, 'Failed to upload to storage: ' + err);
                });
              }).fail(function (err) {
                showUploadError(file.name, 'Failed to get attachment reservation: ' + err);
              });
            });
          });
        } else {
          translationOrder.fromLanguage = $("#orderFromLanguage").val();
          translationOrder.fromLanguageName = $("#orderFromLanguage option:selected").text().trim();
          translationOrder.toLanguage = selectedToLanguages;
          translationOrder.toLanguageNames = $('#orderToLanguage option:selected').map(function () { return $(this).text().trim(); }).get();
          translationOrder.attachmentIds = attachmentIdArray;
          translationOrder.fileNames = Array.from(files).map(f => f.name);

          // TODO: lisää oikea hinta-arvion laskenta, kun backend-tuki on valmis

          sessionStorage.setItem('translationOrder', JSON.stringify(translationOrder));
          window.location.href = $("#orderTranslationNextPageUri").val();
        }
      }

      nextFile(fileCount);
    });
  }

  if (step === 2) {
    if (!translationOrder.toLanguage || !translationOrder.attachmentIds || translationOrder.attachmentIds.length === 0) {
      const rootPath = $("#orderTranslationStep1Uri").val() || (window.location.origin + window.location.pathname.split('/tilaa-kaannos/')[0] + '/tilaa-kaannos/');
      $("#orderTranslationForm").html(`
        <div class="alert alert-warning shadow-sm border-warning p-4 text-center">
            <h4 class="alert-heading fw-bold mb-3"><i class="fas fa-exclamation-triangle me-2"></i>${escapeHtml(currentMsg.orderDataMissing)}</h4>
            <p class="mb-4">${escapeHtml(currentMsg.orderDataMissingText)}</p>
            <a href="${rootPath}" class="btn btn-primary px-4 py-2 fw-bold rounded-3">${escapeHtml(currentMsg.backToStep1)}</a>
        </div>
      `);
      return;
    }
    const toLangs = Array.isArray(translationOrder.toLanguage) ? translationOrder.toLanguage : [translationOrder.toLanguage];

    const fromName = translationOrder.fromLanguageName || translationOrder.fromLanguage;
    const toNames = (translationOrder.toLanguageNames || toLangs).join(", ");
    const fileCount = (translationOrder.fileNames || []).length;

    $("#estimatesContainer").html(`
      <div class="fs-6 text-dark mb-3">
        <strong>${escapeHtml(currentMsg.sourceLanguage)}:</strong> ${escapeHtml(fromName)}
      </div>
      <div class="fs-6 text-dark mb-4">
        <strong>${escapeHtml(currentMsg.targetLanguageTitle)}:</strong> ${escapeHtml(toNames)}
      </div>
      <hr style="border-top: 1px dotted rgba(0,0,0,0.3);">
      <div class="fs-6 text-dark mt-4 mb-2">
        <strong>${escapeHtml(currentMsg.filesTitle)}:</strong> ${fileCount} ${escapeHtml(currentMsg.pcs)}
        <div class="mt-1 text-muted small">
          ${(translationOrder.fileNames || []).map(f => escapeHtml(f)).join(', ')}
        </div>
      </div>
    `);

    if (translationOrder.deadline) $("#orderTranslationDeadline").val(translationOrder.deadline);
    if (translationOrder.notes) $("#orderTranslationNotes").val(translationOrder.notes);

    $("#orderTranslationForm").on("submit", function (e) {
      e.preventDefault();

      translationOrder.deadline = $("#orderTranslationDeadline").val();
      translationOrder.notes = $("#orderTranslationNotes").val();
      sessionStorage.setItem('translationOrder', JSON.stringify(translationOrder));

      const nextPage = $("#orderTranslationNextPageUri").val();
      window.location.href = nextPage;
    });
  }

  // STEP 3 Form
  if (step === 3) {
    if (!translationOrder.toLanguage || !translationOrder.attachmentIds || translationOrder.attachmentIds.length === 0) {
      const rootPath = $("#orderTranslationStep1Uri").val() || (window.location.origin + window.location.pathname.split('/tilaa-kaannos/')[0] + '/tilaa-kaannos/');
      $("#orderTranslationForm").html(`
        <div class="alert alert-warning shadow-sm border-warning p-4 text-center">
            <h4 class="alert-heading fw-bold mb-3"><i class="fas fa-exclamation-triangle me-2"></i>${escapeHtml(currentMsg.orderDataMissing)}</h4>
            <p class="mb-4">${escapeHtml(currentMsg.orderDataMissingText)}</p>
            <a href="${rootPath}" class="btn btn-primary px-4 py-2 fw-bold rounded-3">${escapeHtml(currentMsg.backToStep1)}</a>
        </div>
      `);
      return;
    }
    const fromName = translationOrder.fromLanguageName || translationOrder.fromLanguage;
    const toNames = (translationOrder.toLanguageNames || []).join(", ");
    const fileCount = (translationOrder.attachmentIds || []).length;

    const fileNamesText = (translationOrder.fileNames || []).map(f => escapeHtml(f)).join(", ");
    $("#orderTranslationSummary").html(`
      <div class="d-flex align-items-center justify-content-start text-dark fs-6 px-2">
        <span class="fw-bold me-2 text-dark">${escapeHtml(currentMsg.summary)}</span> 
        <span class="text-dark">${escapeHtml(fromName)}</span>
        <i class="fas fa-arrow-right mx-2 text-dark" style="font-size: 0.9rem;"></i>
        <span class="text-dark">${escapeHtml(toNames)}</span>
        <span class="mx-3 text-muted">|</span>
        <span class="text-dark pe-2">${escapeHtml(currentMsg.attachments)} (${fileCount}): ${fileNamesText}</span>
      </div>
    `);

    if (translationOrder.firstName) $("#orderTranslationFirstName").val(translationOrder.firstName);
    if (translationOrder.lastName) $("#orderTranslationLastName").val(translationOrder.lastName);
    if (translationOrder.email) $("#orderTranslationEmail").val(translationOrder.email);
    if (translationOrder.phone) $("#orderTranslationPhone").val(translationOrder.phone);
    if (translationOrder.organization) $("#orderTranslationOrganization").val(translationOrder.organization);
    if (translationOrder.billingAddress) $("#orderTranslationBillingAddress").val(translationOrder.billingAddress);

    $("#orderTranslationForm").on("submit", function (e) {
      e.preventDefault();

      translationOrder.firstName = $("#orderTranslationFirstName").val();
      translationOrder.lastName = $("#orderTranslationLastName").val();
      translationOrder.email = $("#orderTranslationEmail").val();
      translationOrder.phone = $("#orderTranslationPhone").val();
      translationOrder.organization = $("#orderTranslationOrganization").val();
      translationOrder.billingAddress = $("#orderTranslationBillingAddress").val();

      sessionStorage.setItem('translationOrder', JSON.stringify(translationOrder));

      const toLangs = Array.isArray(translationOrder.toLanguage) ? translationOrder.toLanguage : [translationOrder.toLanguage];
      const toNamesArr = Array.isArray(translationOrder.toLanguageNames) ? translationOrder.toLanguageNames : [translationOrder.toLanguageNames || ""];

      $("#orderTranslationNextBtn").prop('disabled', true).text(currentMsg.sending);

      async function processOrders() {
        try {
          for (let i = 0; i < toLangs.length; i++) {
            const langCode = toLangs[i];
            const langName = toNamesArr[i];

            await new Promise((resolve, reject) => {
              grecaptcha.ready(function () {
                grecaptcha.execute(recaptchaSiteKey, { action: "submit" }).then(function (token) {
                  const singleOrderData = {
                    firstName: translationOrder.firstName,
                    lastName: translationOrder.lastName,
                    email: translationOrder.email,
                    phoneNumber: translationOrder.phone,
                    organizationName: translationOrder.organization,
                    billingInformation: translationOrder.billingAddress,
                    customerNotes: (translationOrder.notes || "") + (translationOrder.deadline ? " | Deadline: " + translationOrder.deadline : ""),
                    fromLanguage: translationOrder.fromLanguage,
                    toLanguage: langCode,
                    toLanguageText: langName,
                    attachmentIds: translationOrder.attachmentIds || [],
                    type: "TRANSLATION",
                    durationInMinutes: 0,
                    recaptchaToken: token
                  };

                  $.ajax({
                    url: envSettings.server + "/json/orders/add",
                    method: "POST",
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: JSON.stringify(singleOrderData)
                  }).done(resolve).fail(reject);
                });
              });
            });
          }

          console.log("All translation orders created successfully");
          sessionStorage.removeItem('translationOrder');
          window.location.href = $("#orderTranslationNextPageUri").val();
        } catch (err) {
          console.error("Failed to create translation orders", err);
          $("#orderTranslationNextBtn").prop('disabled', false).text(currentMsg.submitRequest);
          alert(currentMsg.sendFailed);
        }
      }

      processOrders();
    });
  }
});
